import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        © {new Date().getFullYear()} <strong>Swaad Pickles</strong> — Fresh Homemade Pickles 🌶️
      </p>
      <p style={{ marginTop: 6, fontSize: '0.78rem', color: 'rgba(255,255,255,0.32)' }}>
        Made with ❤️ in Gujarat, India - by Manisha Suthar
      </p>
    </footer>
  );
};

export default Footer;
